import {IForm} from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'content',
      type: 'input',
      label: '发送内容',
      clearable: true,
      placeholder: '请输入发送内容'
    }
    // ,
    // {
    //   field: 'sendStatus',
    //   type: 'select',
    //   label: '发送状态',
    //   clearable: true,
    //   options: [
    //     {title: '待发送', value: ''},
    //     {title: '已发送', value: '1'},
    //   ]
    // }
  ]
}
